import React from 'react';
import Icon, { IconKey } from 'flow/components/ui-components/Icon';
import Tooltip from 'flow/components/ui-components/Tooltip';
import { twMerge } from 'tailwind-merge';

interface Props {
    tooltipLabel: string;
    number?: number;
    icon: IconKey;
    className?: string;
    iconClassName?: string;
}

const BarItemsInfo = ({
    tooltipLabel,
    number,
    icon,
    className,
    iconClassName,
}: Props) => (
    <div className="flex items-center gap-1 text-xs font-medium text-black">
        <Tooltip label={tooltipLabel}>
            <div
                className={twMerge(
                    'flex size-4 items-center justify-center rounded-sm bg-gray-200',
                    className,
                )}
            >
                <Icon
                    iconKey={icon}
                    size="0.75rem"
                    className={twMerge('text-black', iconClassName)}
                />
            </div>
        </Tooltip>
        <span className="min-w-4 text-center">{number}</span>
    </div>
);

export default React.memo(BarItemsInfo);
